import '../project';
import BaseUtils from './base/_utils';
import memoize from 'memoize-one';
import moment from 'moment';
import getSymbolFromCurrency from 'currency-symbol-map';
import Constants from './constants';

const Utils = global.Utils = Object.assign({}, BaseUtils, {
    isCouponValid: (couponId) => {
        return ['TS', 'EY', 'JUNE2230', 'JUNE2215'].includes(couponId);
    },

    calculatePriceWithCoupon: (coupon, planPrice, inCents) => {
        const price = inCents ? planPrice : planPrice / 100;
        if (!coupon) return price;
        switch (coupon.discount_type) {
            case 'percentage': {
                const percentagePrice = price * (1 - (coupon.discount_percentage / 100));
                return inCents ? Math.round(percentagePrice) : percentagePrice;
            }
            case 'fixed_amount': {
                const finalPrice = planPrice - coupon.discount_amount;
                return inCents ? finalPrice : finalPrice / 100;
            }
            default:
                return price;
        }
    },
    getActiveCoupon: (coupons, plan) => {
        const validCoupons = _.sortBy(_.filter(coupons, coupon => {
            if (coupon.plan_constraint === 'specific' && coupon.plan_ids.indexOf(plan.id) === -1) return false;
            if (coupon.discount_type === 'fixed_amount' && coupon.currency_code !== plan.currency_code) return false;
            return coupon.status === 'active';
        }), coupon => coupon.discount_type);
        if (plan.id.includes('student')) {
            if (validCoupons.length > 1) {
                // Prioritise the first not forever coupon
                const oneTimeStudentCoupons = _.filter(validCoupons, coupon => coupon.duration_type === 'one_time');
                return oneTimeStudentCoupons.length ? oneTimeStudentCoupons[0] : validCoupons[0];
            }
        }
        return validCoupons.length ? validCoupons[0] : null;
    },
    isCouponValidForPlan: (coupon, plan) => {
        if (coupon.plan_constraint === 'specific' && coupon.plan_ids.indexOf(plan.id) === -1) return false;
        if (coupon.discount_type === 'fixed_amount' && coupon.currency_code !== plan.currency_code) return false;
        return coupon.status === 'active';
    },
    getCurrencySuffix: (currency_code) => {
        return ['USD', 'AUD', 'CAD'].includes(currency_code) ? ` ${currency_code}` : '';
    },
    getMostRecentSubscription: memoize(subscriptions => _.sortBy(subscriptions, sub => -moment(sub.expires_at).valueOf())[0]),

    isMostRecentSubscriptionExpired: (subscriptions) => {
        const latestSubscription = Utils.getMostRecentSubscription(subscriptions);
        return latestSubscription ? moment(latestSubscription.expires_at).isBefore(moment()) : false;
    },

    renderCoupon: (coupon) => {
        let prefix;
        switch (coupon.discount_type) {
            case 'percentage':
                prefix = coupon.discount_percentage + '%';
                break;
            case 'fixed_amount': {
                const symbol = getSymbolFromCurrency(coupon.currency_code);
                const amountOff = coupon.discount_amount;
                prefix = `${symbol}${amountOff % 100 !== 0 ? (amountOff / 100).toFixed(2) : amountOff / 100}`
                break;
            }
            default:
                return null;
        }

        return prefix;
    },
    getLocaleCodeForCurrency: (locale, currency) => {
        const localeCodePrefix = locale || Constants.defaultLocale
        switch (currency) {
            case 'GBP':
                return `${localeCodePrefix}_GB`;
            case 'CAD':
                return `${localeCodePrefix}_CA`;
            case 'EUR':
                return `${localeCodePrefix}_EU`;
            case 'AUD':
                return `${localeCodePrefix}_AU`;
            default: 
                return `${localeCodePrefix}_US`;
        }
    },
    isMentionMeCouponCode: (couponCode) => {
        const couponPrefix = couponCode.substring(0, 2)
        return ['MM', 'DE'].includes(couponPrefix)
    }
});

export default Utils;
